import { render } from "./EventCard.vue?vue&type=template&id=e50a388a&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=e50a388a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e50a388a"

export default script